export function isSponsoredOp(args) {
    if (args.entryPointVersion === '0.6') {
        return args.paymasterAndData !== undefined && args.paymasterAndData !== '0x';
    }
    else {
        return args.paymasterData !== undefined;
    }
}
